import PrivateRoute from 'components/PrivateRoute';
import React from 'react';
import { Switch } from 'react-router';
import PraticalFieldListPage from './pages/PraticalFieldListPage';
import PraticalFieldFormPage from './pages/PraticalFieldFormPage';

export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/campos-pratica"
      permission="academico.view_praticalfield"
      component={PraticalFieldListPage}
    />
    <PrivateRoute
      exact
      path="/campos-pratica/:id/edit"
      permission="academico.change_praticalfield"
      component={PraticalFieldFormPage}
    />
    <PrivateRoute
      exact
      path="/campos-pratica/new"
      permission="academico.add_praticalfield"
      component={PraticalFieldFormPage}
    />
  </Switch>
);
